// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import ManageSupplier from '@/components/supplier/manage';
import BillingService from '@/services/billing-service';
import SubscriptionContext from '@/utils/subscription-context';
import { createFileRoute } from '@tanstack/react-router'



function CreateSupplier() {

    const subscriptionContext = useContext(SubscriptionContext);
    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
    const [multiStoreTenant, setMultiStoreTenant] = useState(false);

    const getAccessStatus = async () => {
        const [subscriptionInfo, _] = await BillingService.getSubcriptionInfo(subscriptionContext);
        if (subscriptionInfo) {
          setAccessStatus(subscriptionInfo.AccessStatus);
          setMultiStoreTenant(subscriptionInfo.MultiStore);
        }
    };
    
    useEffect(() => {
        getAccessStatus();
    }, []);
      
    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace,"/");
        }
    }, [accessStatus]);

    return (
        <div>
            <ManageSupplier isNew={true} accessStatus={accessStatus} multiTenantStore={multiStoreTenant} />
        </div>
    );
}

export default CreateSupplier;

export const Route = createFileRoute('/_authenticated/supplier/create')({ component: CreateSupplier })
